import { Appearance, DraftConfiguration, PrintArea, PrintType, ProductType } from '@/types';
import { getDefaultPrintAreaForView } from '@/model/productType/getDefaultPrintAreaForView';
import { getDefaultView } from '@/model/productType/getDefaultView';
import { getViewByPerspective } from '@/model/productType/getViewByPerspective';
import { getPossiblePrintTypes } from './getPossiblePrintTypes';
import { getViewFromConfiguration } from './getViewFromConfiguration';

export function findSuitablePrintArea(
  configuration: DraftConfiguration,
  currentProductType: ProductType,
  nextProductType: ProductType,
  appearance: Appearance
): [PrintArea | undefined, PrintType[]] {
  const configurationView = getViewFromConfiguration(currentProductType, configuration);
  const targetView = getViewByPerspective(nextProductType, configurationView.perspective);

  let targetViewPrintArea: PrintArea | undefined;
  let possiblePrintTypes: PrintType[] = [];
  if (targetView) {
    targetViewPrintArea = getDefaultPrintAreaForView(nextProductType, targetView);
    if (targetViewPrintArea) {
      possiblePrintTypes = getPossiblePrintTypes(configuration, targetViewPrintArea, appearance);
      if (possiblePrintTypes.length) {
        return [targetViewPrintArea, possiblePrintTypes];
      }
    }
  }
  // either no view with matching perspective or target view is not printable
  const defaultView = getDefaultView(nextProductType);
  const defaultViewPrintArea = getDefaultPrintAreaForView(nextProductType, defaultView);
  if (defaultViewPrintArea) {
    possiblePrintTypes = getPossiblePrintTypes(configuration, defaultViewPrintArea, appearance);
    if (possiblePrintTypes.length) {
      return [defaultViewPrintArea, possiblePrintTypes];
    }
  }

  // default view printarea is also unusable, iterate over remaining areas to find a suitable one
  const fallbackPrintArea = nextProductType.printAreas
    .filter(
      (pa) =>
        !pa.deprecated &&
        (!defaultViewPrintArea || defaultViewPrintArea.id !== pa.id) &&
        (!targetViewPrintArea || targetViewPrintArea.id !== pa.id)
    )
    .find((pa) => {
      possiblePrintTypes = getPossiblePrintTypes(configuration, pa, appearance);
      return Boolean(possiblePrintTypes.length);
    });
  return [fallbackPrintArea, possiblePrintTypes];
}
